import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getRecordList = async (params: object) => {
  return await GET({ url: Api.getRecordList, params, showError: false })
}
